import { render, staticRenderFns } from "./OrderBoxLocal.vue?vue&type=template&id=071a9fc0&scoped=true&"
import script from "./OrderBoxLocal.vue?vue&type=script&lang=js&"
export * from "./OrderBoxLocal.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoxLocal.vue?vue&type=style&index=0&id=071a9fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a9fc0",
  null
  
)

export default component.exports